import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type AiFredConversationId = Branded<string, "AiFredConversationId">;
const {
    zodSchema: AiFredConversationIdZodSchema,
    factory: aiFredConversationIdFactory,
    assert: isAiFredConversationId,
} = genericId<AiFredConversationId>("aifred_chat__", {
    regexMatch: /(^aifred_chat__.*$)/,
});

export {
    aiFredConversationIdFactory,
    AiFredConversationIdZodSchema,
    isAiFredConversationId,
};
export type { AiFredConversationId };
